const MANIFEST_THEMES = {
    holiday: {
        hashed: 'holiday.2419a7548c462e7b3a88bd2743c75e54.min.css',
        versioned: 'holiday.min.css'
    }
};

export { MANIFEST_THEMES };
